export const translations = {
  
  en: {
    
    // Home Page
    welcomeSalons: "Discover top hair salons near you",
    welcomeBarbers: "Discover top barbers near you",
    searchSalons: "Search salons or stylists...",
    searchBarbers: "Search barbershops or barbers...",
    bookNow: "Book Now",
    trending: "🔥 Trending This Week",
    topRated: "Top Rated",
    noShops: "No locations found matching your filters.",
    howItWorksTop: "How it works",
    howItWorksTitle: "Three steps to a fresh look.",
    step1Title: "Discover",
    step1Desc: "Search by city, service, or professional. Filter by rating, vibe, or price.",
    step2Title: "Book",
    step2Desc: "Pick your professional and a time that works. Confirm in 30 seconds.",
    step3Title: "Show up",
    step3Desc: "Arrive sharp. Leave sharper. Rate your experience and follow them.",
    stats1: "Locations on Platform",
    stats2: "Appointments Booked",
    stats3: "Cities & Counting",
    forProsSubtitle: "For Professionals & Owners",
    forProsTitle: "Run your shop on the network built for the trade.",
    forProsDesc: "Whether you own the chairs or rent one, BookMyStyle gives you a profile, a calendar, and customers who actually show up.",
    listShopBtn: "LIST YOUR SHOP ➔",
    profRules: "Your profile, your rules",
    profRulesDesc: "Bio, services, prices — owned by you, not the shop.",
    lookbook: "Lookbook",
    lookbookDesc: "Show your best work. Photos sell better than words.",
    clientAcc: "Client Account",
    goToDash: "📊 Go to Dashboard",
    logout: "🚪 Logout",
    
    // Team & Sidebar
    ourPros: "Our Professionals",
    noBarbersYet: "This shop hasn't added any barbers yet.",
    servicesAvail: "Services Available",
    tapLookbook: "📸 TAP TO VIEW LOOKBOOK",
    lookbookTitle: "Lookbook",
    lookbookSub: "Signature styles, fades, and previous cuts.",
    shopLoc: "📍 Shop Location",
    mapNotSet: "Map coordinates not set",
    openHours: "📅 Opening Hours",
    closed: "Closed",
    notSet: "Not set",
    
    // Hero & Reviews
    reviews: "Reviews",
    rateExp: "Rate your experience:",
    writeRev: "Write your review...",
    submit: "Submit",

    joinPlatform: "Join our platform",
selectAccount: "Select your account type to continue",
iamClient: "I am a Client",
clientDesc: "Book appointments, manage your schedule, and leave reviews.",
continueClient: "Continue as Client",
iamPartner: "I am the Owner",
partnerDesc: "Register your location, manage services, and invite staff.",
continuePartner: "Continue as Owner",
iamStaff: "I am Staff",
staffDesc: "View your daily schedule and check assigned appointments.",
continueStaff: "Continue as Staff",
    
    // Client Dashboard
    hello: "Hello",
    welcomeDash: "Welcome to your personal dashboard.",
    findBarber: "🔍 Find a Barber",
    backHome: "💈 Back to Home",
    upcApps: "Upcoming Appointments",
    cancel: "Cancel",
    reschedule: "Reschedule",
    addCal: "📅 Add to Calendar",
    myBookings: "📅 My Bookings",
    favShops: "❤️ Favorite Shops",
    settings: "⚙️ Settings",
    noApps: "You have no upcoming appointments.",
    bookFirst: "Book your first haircut",
    noFavs: "You haven't saved any shops to your favorites yet.",
    accSettings: "Account Settings",
    fullName: "Full Name",
    emailAddr: "Email Address",
    cityLoc: "Your City / Location",
    saveSet: "Save Settings",
    saving: "Saving...",
    rescheduleSub: "Move your appointment with",
    newDate: "New Date",
    availTime: "Available Time",
    selectTime: "Select a time...",
    noSlots: "No slots available for this duration",
    confReschedule: "Confirm Reschedule",
    locationTBD: "Location TBD",
 
    // Partner Dashboard
    shopAdmin: "Shop Admin",
    manageSubtitle: "Manage your barbershop, team, and settings.",
    shareToClients: "📲 Share to Clients",
    viewLivePage: "View Live Page",
    teamAndServices: "✂️ Team & Services",
    calendarNotSynced: "Calendar Not Synced",
    calendarNotSyncedDesc: "Connect your Google Calendar to sync appointments and prevent double bookings.",
    fixNow: "Fix Now",
    welcomeBack: "Welcome back",
    revenueGenerated: "Total Revenue Generated",
    totalClients: "Total Completed Clients",
    revenueTrend: "Revenue Trend (Past Days)",
    noRevenueData: "No revenue data yet.",
    topEarning: "Top Earning Professionals",
    noBarberData: "No barber data yet.",
    shopQrCode: "Shop Booking QR Code",
    shopQrDesc: "Print this and put it on your mirror. Clients can scan to book or register instantly.",
    copyDirectLink: "🔗 Copy Direct Link",
    linkCopied: "Booking link copied to clipboard!",
    googleCalSync: "Google Calendar Sync",
    googleCalDesc: "Automatically push new appointments to your personal Google Calendar to prevent double booking.",
    connectCalendar: "Connect Calendar",
    connectedGoogle: "✓ Connected to Google",
    staffInviteCode: "Staff Invite Code",
    staffInviteDesc: "Give this code to your barbers when they register.",
    shopProfileSetup: "Shop Profile Setup",
    mapAddressLabel: "Real Map Address (Required for Pins)",
    mapAddressPlaceholder: "Start typing real address...",
    shopCoverPhoto: "Shop Cover Photo",
    changePhoto: "Change Photo",
    uploadCoverPhoto: "Upload Cover Photo",
    shopVibes: "Shop Vibes (Select up to 3)",
    saveShopProfile: "Save Shop Profile",
    dangerZone: "Danger Zone",
    dangerZoneDesc: "Permanently delete your shop, all scheduled appointments, and your account.",
    deleteMyShop: "Delete My Shop",
    deleteConfirm: "⚠️ WARNING ⚠️\nAre you sure you want to permanently delete your shop, all barbers, and your account? This action CANNOT be undone.",
    addNewBarber: "Add New Barber",
    addPhoto: "📷 Add Photo",
    photoAttached: "Photo Attached ✅",
    barberNamePlaceholder: "Barber Name...",
    addBarberBtn: "+ Add Barber",
    currentTeam: "Current Team",
    noBarbersAdmin: "No barbers added yet.",
    updatePhoto: "Update Photo",
    thisIsMe: "🙋‍♂️ This is me",
    thisIsYou: "✓ This is you",
    addService: "+ Add Service",
    addPortfolioPhoto: "+ Add Portfolio Photo",
    deletePhotoConfirm: "Delete this photo?",
    myPersonalSchedule: "My Personal Schedule",
    whichProfileTitle: "Which profile is yours?",
    whichProfileDesc: "You haven't told us which professional you are yet. Go to the Team tab and click \"This is me\" next to your name to unlock your schedule.",
    goToTeamTab: "Go to Team Tab",
    myPortfolio: "My Portfolio",
    addPhotoBtn: "+ Add Photo",
    noPortfolioDesc: "You haven't uploaded any photos yet. Add some to show up in the Community Feed!",
    dailyCalendar: "Daily Calendar",
    shopClosedDate: "Shop is closed on this date.",
    confirmed: "Confirmed",
    availableSlot: "Available Slot",
    addWalkIn: "+ Add Walk-in",
    walkInNamePrompt: "Enter Walk-in Client Name:",
    walkInServicePrompt: "Enter Service Name (e.g. Haircut):",
    walkInAdded: "Walk-in added! Refresh the page to see it on the grid.",
    profileNotFound: "Profile not found.",
    addNewService: "Add New Service",
    serviceName: "Service Name",
    price: "Price",
    duration: "Duration",
    durationPlaceholder: "e.g. 30m or 1h",
    saveService: "Save Service",
    profileLinkedSuccess: "Success! This profile is now linked to your owner account.",
    settingsSaved: "Shop Settings Saved! Your profile is updated.",
    inviteShareText: "Book your next haircut with us on BookMyStyle! Search our shop or use our code:",
    inviteShareTitle: "Book with us on BookMyStyle",
    inviteShareCopied: "Invite code and link copied to clipboard! You can now paste it in Instagram or WhatsApp.",
    
    // Footer
    forClients: "For Clients",
    searchLocations: "Search Locations",
    leaveReview: "Leave a Review",
    supportCenter: "Support Center",
    forPartners: "For Owners",
    registerShop: "Register your Shop",
    pricingPlans: "Pricing Plans",
    partnerDashboard: "Owner Dashboard",
    staffManagement: "Staff Management",
    howItWorksTitle: "How It Works",
    forClients: "For Clients",
    forProfessionals: "For Professionals",
    forOwners: "For Shop Owners",
    tabClients: "Clients",
    tabStaff: "Professionals",
    tabOwners: "Shop Owners",
    stepText: "STEP",
    backToHome: "← Back to Home",
    clientStep1Title: "Discover & Choose",
    clientStep1Desc: "Browse top-rated professionals in your city. Filter by vibes, services, and availability to find your perfect match.",
    clientStep2Title: "Book Instantly",
    clientStep2Desc: "Select an open time slot and book your appointment in seconds. No more back-and-forth phone calls or waiting for replies.",
    clientStep3Title: "Show Up & Enjoy",
    clientStep3Desc: "Arrive at the shop, enjoy your premium service, and leave looking your best. Payment and reviews are handled seamlessly.",
    staffStep1Title: "Build Your Portfolio",
    staffStep1Desc: "Upload photos of your best cuts to your personal lookbook. Your work feeds directly into the city-wide community page.",
    staffStep2Title: "Control Your Chair",
    staffStep2Desc: "Set your specific services, duration, and prices. Update your daily story to let clients know when you have a free spot.",
    staffStep3Title: "Build Loyalty",
    staffStep3Desc: "Clients can favorite your profile and book you directly. Turn one-time walk-ins into lifelong regular customers.",
    ownerStep1Title: "Register & Setup Profile",
    ownerStep1Desc: "Create your owner account. Upload a high-quality cover photo, set your physical address, and drop the exact map pin so clients can easily navigate to your door.",
    ownerStep2Title: "Define Your Vibe & Hours",
    ownerStep2Desc: "Select up to 3 vibe tags (like 'PS5 Lounge' or 'Free Beer') to attract your ideal clientele. Configure your weekly working hours so clients know exactly when your doors are open.",
    ownerStep3Title: "Add Barbers & Services",
    ownerStep3Desc: "Generate a unique Staff Invite Code. As your barbers create accounts and join your shop, you can define their specific services, prices, and durations.",
    ownerStep4Title: "Sync & Manage",
    ownerStep4Desc: "Connect your Google Calendar to prevent double-bookings. Manage walk-ins directly from your dashboard while online bookings automatically populate your master schedule.",
    ownerStep5Title: "Launch & Grow",
    ownerStep5Desc: "Print your custom shop QR code and put it on your mirrors. Let clients book their next cut right from the chair, track your daily revenue analytics, and watch your business scale.",
  },





 
  al: {

    joinPlatform: "Bashkohuni me platformën tonë",
selectAccount: "Zgjidhni llojin e llogarisë për të vazhduar",
iamClient: "Unë jam Klient",
clientDesc: "Rezervoni takime, menaxhoni kalendarin dhe lini vlerësime.",
continueClient: "Vazhdo si Klient",
iamPartner: "Unë jam Pronari",
partnerDesc: "Regjistroni biznesin, menaxhoni shërbimet dhe ftoni stafin.",
continuePartner: "Vazhdo si Pronar",
iamStaff: "Unë jam Staf",
staffDesc: "Shikoni orarin ditor dhe kontrolloni takimet e caktuara.",
continueStaff: "Vazhdo si Staf",

    // Home Page
    welcomeSalons: "Zbuloni sallonet më të mira pranë jush",
    welcomeBarbers: "Zbuloni berberët më të mirë pranë jush",
    searchSalons: "Kërko sallone ose stilistë...",
    searchBarbers: "Kërko berberë...",
    bookNow: "Rezervo Tani",
    trending: "🔥 Në Trend Këtë Javë",
    topRated: "Më të Vlerësuarit",
    noShops: "Nuk u gjet asnjë dyqan me këto filtra.",
    howItWorksTop: "Si funksionon",
    howItWorksTitle: "Tre hapa për një pamje të re.",
    step1Title: "Zbulo",
    step1Desc: "Kërko sipas qytetit, shërbimit, ose profesionistit. Filtro sipas vlerësimit, atmosferës ose çmimit.",
    step2Title: "Rezervo",
    step2Desc: "Zgjidh profesionistin dhe orarin e përshtatshëm. Konfirmo në 30 sekonda.",
    step3Title: "Paraqitu",
    step3Desc: "Mbërri në kohë. Lër një vlerësim për shërbimin dhe ndiqi ata.",
    stats1: "Vendndodhje në Platformë",
    stats2: "Takime të Rezervuara",
    stats3: "Qytete & në Rritje",
    forProsSubtitle: "Për Profesionistët & Pronarët",
    forProsTitle: "Drejto biznesin tënd në rrjetin e ndërtuar për ty.",
    forProsDesc: "Pavarësisht nëse ke karrige apo e merr me qira, BookMyStyle të jep profil, kalendar, dhe klientë që vërtet paraqiten.",
    listShopBtn: "LISTO BIZNESIN TËND ➔",
    profRules: "Profili yt, rregullat e tua",
    profRulesDesc: "Bio, shërbimet, çmimet — të menaxhuara nga ti, jo nga dyqani.",
    lookbook: "Portofoli (Lookbook)",
    lookbookDesc: "Trego punët e tua më të mira. Fotot shesin më shumë se fjalët.",
    clientAcc: "Llogari Klienti",
    goToDash: "📊 Shko tek Paneli",
    logout: "🚪 Dil",
    
    // Team & Sidebar
    ourPros: "Profesionistët Tanë",
    noBarbersYet: "Ky dyqan nuk ka shtuar asnjë profesionist ende.",
    servicesAvail: "Shërbime të Vlefshme",
    tapLookbook: "📸 SHIKO PORTOFOLIN",
    lookbookTitle: "Portofoli (Lookbook)",
    lookbookSub: "Stilet e veçanta dhe prerjet e mëparshme.",
    shopLoc: "📍 Vendndodhja",
    mapNotSet: "Koordinatat e hartës nuk janë caktuar",
    openHours: "📅 Orari i Punës",
    closed: "Mbyllur",
    notSet: "E pacaktuar",
    
    // Hero & Reviews
    reviews: "Vlerësime",
    rateExp: "Vlerëso përvojën tënde:",
    writeRev: "Shkruaj vlerësimin tënd...",
    submit: "Dërgo",
    
    // Client Dashboard
    hello: "Përshëndetje",
    welcomeDash: "Mirësevini në panelin tuaj personal.",
    findBarber: "🔍 Gjej një Berber",
    backHome: "💈 Kthehu në Kryefaqe",
    upcApps: "Takimet e Ardhshme",
    cancel: "Anulo",
    reschedule: "Rishtyj",
    addCal: "📅 Shto në Kalendar",
    myBookings: "📅 Rezervimet e mia",
    favShops: "❤️ Dyqanet e preferuara",
    settings: "⚙️ Cilësimet",
    noApps: "Nuk keni asnjë takim të ardhshëm.",
    bookFirst: "Rezervoni prerjen tuaj të parë",
    noFavs: "Nuk keni ruajtur asnjë dyqan tek të preferuarat.",
    accSettings: "Cilësimet e Llogarisë",
    fullName: "Emri i Plotë",
    emailAddr: "Adresa e Email-it",
    cityLoc: "Qyteti / Vendndodhja juaj",
    saveSet: "Ruaj Cilësimet",
    saving: "Duke ruajtur...",
    rescheduleSub: "Shtyni takimin tuaj me",
    newDate: "Data e Re",
    availTime: "Ora e Vlefshme",
    selectTime: "Zgjidhni një orar...",
    noSlots: "Nuk ka orare të lira për këtë kohëzgjatje",
    confReschedule: "Konfirmo Shtyrjen",
    locationTBD: "E pacaktuar",
 
    // Partner Dashboard
    shopAdmin: "Administrim Dyqani",
    manageSubtitle: "Menaxho dyqanin, ekipin dhe cilësimet tuaja.",
    shareToClients: "📲 Ndaj me Klientët",
    viewLivePage: "Shiko Faqen Live",
    teamAndServices: "✂️ Ekipi & Shërbimet",
    calendarNotSynced: "Kalendari nuk është sinkronizuar",
    calendarNotSyncedDesc: "Lidh Google Kalendarin tënd për të sinkronizuar takimet dhe shmangur rezervimet e dyfishta.",
    fixNow: "Rregulllo Tani",
    welcomeBack: "Mirë se u ktheve",
    revenueGenerated: "Të Ardhura Totale të Gjeneruara",
    totalClients: "Klientë Totale të Shërbyer",
    revenueTrend: "Tendenca e të Ardhurave (Ditët e Fundit)",
    noRevenueData: "Nuk ka të dhëna për të ardhurat ende.",
    topEarning: "Profesionistët më Fitimprurës",
    noBarberData: "Nuk ka të dhëna për berberët ende.",
    shopQrCode: "Kodi QR i Rezervimit të Dyqanit",
    shopQrDesc: "Printo këtë dhe vendose në pasqyrën tënde. Klientët mund të skanojnë për të rezervuar.",
    copyDirectLink: "🔗 Kopjo Linkun Direkt",
    linkCopied: "Linku i rezervimit u kopjua!",
    googleCalSync: "Sinkronizim me Google Kalendar",
    googleCalDesc: "Shtyj automatikisht takimet e reja në Google Kalendarin tënd personal.",
    connectCalendar: "Lidhu me Kalendarin",
    connectedGoogle: "✓ Lidhur me Google",
    staffInviteCode: "Kodi i Ftesës për Stafin",
    staffInviteDesc: "Jepja këtë kod berberëve tuaj kur regjistrohen.",
    shopProfileSetup: "Konfigurimi i Profilit të Dyqanit",
    mapAddressLabel: "Adresa e Hartës (E Nevojshme për Pinët)",
    mapAddressPlaceholder: "Fillo të shkruash adresën e vërtetë...",
    shopCoverPhoto: "Foto e Kopertinës së Dyqanit",
    changePhoto: "Ndrysho Foton",
    uploadCoverPhoto: "Ngarko Foto Kopertine",
    shopVibes: "Atmosfera e Dyqanit (Zgjidhni deri në 3)",
    saveShopProfile: "Ruaj Profilin e Dyqanit",
    dangerZone: "Zona e Rrezikut",
    dangerZoneDesc: "Fshi përgjithmonë dyqanin, të gjitha takimet e planifikuara dhe llogarinë tuaj.",
    deleteMyShop: "Fshi Dyqanin Tim",
    deleteConfirm: "⚠️ KUJDES ⚠️\nJeni të sigurt që doni të fshini përgjithmonë dyqanin, berberët dhe llogarinë? Ky veprim NUK mund të zhbëhet.",
    addNewBarber: "Shto Berber të Ri",
    addPhoto: "📷 Shto Foto",
    photoAttached: "Foto e Bashkangjitur ✅",
    barberNamePlaceholder: "Emri i Berberit...",
    addBarberBtn: "+ Shto Berberin",
    currentTeam: "Ekipi Aktual",
    noBarbersAdmin: "Nuk ka berberë të shtuar ende.",
    updatePhoto: "Ndrysho Foton",
    thisIsMe: "🙋‍♂️ Ky jam unë",
    thisIsYou: "✓ Ky je ti",
    addService: "+ Shto Shërbim",
    addPortfolioPhoto: "+ Shto Foto në Portofol",
    deletePhotoConfirm: "Fshi këtë foto?",
    myPersonalSchedule: "Orari Im Personal",
    whichProfileTitle: "Cili profil është yti?",
    whichProfileDesc: "Nuk na ke treguar ende cilin profesionist je. Shko tek skeda e Ekipit dhe kliko 'Ky jam unë' pranë emrit tënd.",
    goToTeamTab: "Shko tek Skeda e Ekipit",
    myPortfolio: "Portofoli Im",
    addPhotoBtn: "+ Shto Foto",
    noPortfolioDesc: "Nuk ke ngarkuar asnjë foto ende. Shto disa për t'u shfaqur në Burim!",
    dailyCalendar: "Kalendari Ditor",
    shopClosedDate: "Dyqani është mbyllur në këtë datë.",
    confirmed: "Konfirmuar",
    availableSlot: "Vend i Lirë",
    addWalkIn: "+ Shto Walk-in",
    walkInNamePrompt: "Shkruaj Emrin e Klientit Walk-in:",
    walkInServicePrompt: "Shkruaj Emrin e Shërbimit (p.sh. Prerje flokësh):",
    walkInAdded: "Walk-in u shtua! Rifresko faqen për ta parë në rrjet.",
    profileNotFound: "Profili nuk u gjet.",
    addNewService: "Shto Shërbim të Ri",
    serviceName: "Emri i Shërbimit",
    price: "Çmimi",
    duration: "Kohëzgjatja",
    durationPlaceholder: "p.sh. 30m ose 1h",
    saveService: "Ruaj Shërbimin",
    profileLinkedSuccess: "Sukses! Ky profil është lidhur me llogarinë tuaj si pronar.",
    settingsSaved: "Cilësimet e Dyqanit u Ruajtën! Profili juaj është përditësuar.",
    inviteShareText: "Rezervo prerjen tënde të ardhshme me ne në BookMyStyle! Kërko dyqanin tonë ose përdor kodin tonë:",
    inviteShareTitle: "Rezervo me ne në BookMyStyle",
    inviteShareCopied: "Kodi i ftesës dhe linku u kopjuan! Mund t'i ngasësh në Instagram ose WhatsApp.",
    
    // Footer
    forClients: "Për Klientët",
    searchLocations: "Kërko Vendndodhje",
    leaveReview: "Lër një Vlerësim",
    supportCenter: "Qendra e Ndihmës",
    forPartners: "Për Pronarët",
    registerShop: "Regjistro Biznesin",
    pricingPlans: "Planet e Çmimeve",
    partnerDashboard: "Paneli i Pronarëve",
    staffManagement: "Menaxhimi i Stafit",

    howItWorksTitle: "Si Funksionon",
    forClients: "Për Klientët",
    forProfessionals: "Për Profesionistët",
    forOwners: "Për Pronarët",
    tabClients: "Klientët",
    tabStaff: "Profesionistët",
    tabOwners: "Pronarët",
    stepText: "HAPI",
    backToHome: "← Kthehu në Ballina",
    clientStep1Title: "Zbulo dhe Zgjidh",
    clientStep1Desc: "Shfleto profesionistët më të vlerësuar në qytetin tënd. Filtro sipas atmosferës, shërbimeve dhe disponueshmërisë për të gjetur zgjedhjen perfekte.",
    clientStep2Title: "Rezervo Menjëherë",
    clientStep2Desc: "Zgjidh një orar të lirë dhe rezervo takimin tënd në pak sekonda. Nuk ka më telefonata të pafundme apo pritje për përgjigje.",
    clientStep3Title: "Paraqitu dhe Shijo",
    clientStep3Desc: "Mberri në sallon, shijo shërbimin tënd premium dhe largohu me pamjen tënde më të mirë. Pagesa dhe vlerësimet menaxhohen pa problem.",
    staffStep1Title: "Krijo Portofolin Tënd",
    staffStep1Desc: "Ngarko fotot e prerjeve të tua më të mira në lookbook-un tënd personal. Puna jote publikohet drejtpërdrejt në faqen e komunitetit të qytetit.",
    staffStep2Title: "Kontrollo Karrigen Tënde",
    staffStep2Desc: "Vendos shërbimet e tua specifike, kohëzgjatjen dhe çmimet. Përditëso story-n tënd ditor për t'u bërë të ditur klientëve kur ke një vend të lirë.",
    staffStep3Title: "Krijo Besnikëri",
    staffStep3Desc: "Klientët mund të shtojnë profilin tënd në të preferuarat dhe të rezervojnë drejtpërdrejt. Kthe klientët e rastësishëm në klientë të rregullt të përjetshëm.",
    ownerStep1Title: "Regjistrohu dhe Krijo Profilin",
    ownerStep1Desc: "Krijo llogarinë tënde të pronarit. Ngarko një foto cover me cilësi të lartë, vendos adresën tënde fizike dhe vendos pin-in e saktë në hartë në mënyrë që klientët të mund të gjejnë lehtësisht derën tënde.",
    ownerStep2Title: "Përcakto Atmosferën & Oraret",
    ownerStep2Desc: "Zgjidh deri në 3 tag-e atmosfere (si 'Sallon PS5' ose 'Birrë Falas') për të tërhequr klientelën tënde ideale. Konfiguro oraret e tua javore të punës në mënyrë që klientët të dinë saktësisht kur dyert e tua janë të hapura.",
    ownerStep3Title: "Shto Berberë dhe Shërbime",
    ownerStep3Desc: "Gjenero një Kod Ftese unik për Stafin. Teksa berberët e tu krijojnë llogari dhe i bashkohen sallonit tënd, mund të përcaktosh shërbimet, çmimet dhe kohëzgjatjet e tyre specifike.",
    ownerStep4Title: "Sinkronizo dhe Menaxho",
    ownerStep4Desc: "Lidh Google Calendar-in tënd për të parandaluar rezervimet e dyfishta. Menaxho klientët pa takim drejtpërdrejt nga dashboard-i yt ndërkohë që rezervimet online plotësojnë automatikisht kalendarin tënd kryesor.",
    ownerStep5Title: "Fillo dhe Rritu",
    ownerStep5Desc: "Printo kodin QR të personalizuar të sallonit tënd dhe vendose në pasqyrat e tua. Lëri klientët të rezervojnë prerjen e tyre të radhës direkt nga karrigia, gjurmo të ardhurat e tua ditore dhe shiko biznesin tënd të rritet."
  },





 
  it: {
    // Home Page
    welcomeSalons: "Scopri i migliori parrucchieri vicino a te",
    welcomeBarbers: "Scopri i migliori barbieri vicino a te",
    searchSalons: "Cerca parrucchieri o stilisti...",
    searchBarbers: "Cerca barbieri...",
    bookNow: "Prenota Ora",
    trending: "🔥 In Tendenza Questa Settimana",
    topRated: "I Più Votati",
    noShops: "Nessun salone trovato con questi filtri.",
    howItWorksTop: "Come funziona",
    howItWorksTitle: "Tre passi per un nuovo look.",
    step1Title: "Scopri",
    step1Desc: "Cerca per città, servizio o professionista. Filtra per valutazione, atmosfera o prezzo.",
    step2Title: "Prenota",
    step2Desc: "Scegli il tuo professionista e un orario. Conferma in 30 secondi.",
    step3Title: "Presentati",
    step3Desc: "Arriva puntuale. Lascia una recensione e seguili.",
    stats1: "Saloni sulla Piattaforma",
    stats2: "Prenotazioni Effettuate",
    stats3: "Città e Oltre",
    forProsSubtitle: "Per Professionisti e Proprietari",
    forProsTitle: "Gestisci il tuo salone sulla rete creata per te.",
    forProsDesc: "Sia che tu possieda il salone o affitti una poltrona, BookMyStyle ti offre un profilo, un calendario e clienti che si presentano davvero.",
    listShopBtn: "REGISTRA IL TUO SALONE ➔",
    profRules: "Il tuo profilo, le tue regole",
    profRulesDesc: "Bio, servizi, prezzi — gestiti da te, non dal salone.",
    lookbook: "Portfolio (Lookbook)",
    lookbookDesc: "Mostra i tuoi lavori migliori. Le foto vendono più delle parole.",
    clientAcc: "Account Cliente",
    goToDash: "📊 Vai alla Dashboard",
    logout: "🚪 Esci",
    
    // Team & Sidebar
    ourPros: "I Nostri Professionisti",
    noBarbersYet: "Questo salone non ha ancora aggiunto professionisti.",
    servicesAvail: "Servizi Disponibili",
    tapLookbook: "📸 TOCCA PER VEDERE IL PORTFOLIO",
    lookbookTitle: "Portfolio (Lookbook)",
    lookbookSub: "Stili distintivi, sfumature e tagli precedenti.",
    shopLoc: "📍 Posizione del Salone",
    mapNotSet: "Coordinate della mappa non impostate",
    openHours: "📅 Orari di Apertura",
    closed: "Chiuso",
    notSet: "Non impostato",
    
    // Hero & Reviews
    reviews: "Recensioni",
    rateExp: "Valuta la tua esperienza:",
    writeRev: "Scrivi la tua recensione...",
    submit: "Invia",
    
    // Client Dashboard
    hello: "Ciao",
    welcomeDash: "Benvenuto nella tua dashboard personale.",
    findBarber: "🔍 Trova un Barbiere",
    backHome: "💈 Torna alla Home",
    upcApps: "Prossimi Appuntamenti",
    cancel: "Annulla",
    reschedule: "Riprogramma",
    addCal: "📅 Aggiungi al Calendario",
    myBookings: "📅 Le mie Prenotazioni",
    favShops: "❤️ Saloni Preferiti",
    settings: "⚙️ Impostazioni",
    noApps: "Non hai appuntamenti imminenti.",
    bookFirst: "Prenota il tuo primo taglio",
    noFavs: "Non hai ancora salvato nessun salone tra i preferiti.",
    accSettings: "Impostazioni Account",
    fullName: "Nome Completo",
    emailAddr: "Indirizzo Email",
    cityLoc: "Tua Città / Posizione",
    saveSet: "Salva Impostazioni",
    saving: "Salvataggio...",
    rescheduleSub: "Sposta il tuo appuntamento con",
    newDate: "Nuova Data",
    availTime: "Orario Disponibile",
    selectTime: "Seleziona un orario...",
    noSlots: "Nessun orario disponibile per questa durata",
    confReschedule: "Conferma Riprogrammazione",
    locationTBD: "Da definire",

    joinPlatform: "Unisciti alla nostra piattaforma",
selectAccount: "Seleziona il tipo di account per continuare",
iamClient: "Sono un Cliente",
clientDesc: "Prenota appuntamenti, gestisci il tuo programma e lascia recensioni.",
continueClient: "Continua come Cliente",
iamPartner: "Sono il Proprietario",
partnerDesc: "Registra la tua sede, gestisci i servizi e invita lo staff.",
continuePartner: "Continua come Proprietario",
iamStaff: "Sono dello Staff",
staffDesc: "Visualizza il tuo programma giornaliero e controlla gli appuntamenti assegnati.",
continueStaff: "Continua come Staff",
 
    // Partner Dashboard
    shopAdmin: "Amministrazione Salone",
    manageSubtitle: "Gestisci il tuo salone, il team e le impostazioni.",
    shareToClients: "📲 Condividi con i Clienti",
    viewLivePage: "Vedi Pagina Live",
    teamAndServices: "✂️ Team e Servizi",
    calendarNotSynced: "Calendario Non Sincronizzato",
    calendarNotSyncedDesc: "Collega il tuo Google Calendar per sincronizzare gli appuntamenti ed evitare doppie prenotazioni.",
    fixNow: "Risolvi Ora",
    welcomeBack: "Ben tornato",
    revenueGenerated: "Entrate Totali Generate",
    totalClients: "Clienti Totali Serviti",
    revenueTrend: "Andamento Entrate (Giorni Precedenti)",
    noRevenueData: "Nessun dato sulle entrate ancora.",
    topEarning: "Professionisti con Maggiori Guadagni",
    noBarberData: "Nessun dato sui barbieri ancora.",
    shopQrCode: "QR Code Prenotazione Salone",
    shopQrDesc: "Stampalo e mettilo sul tuo specchio. I clienti possono scansionarlo per prenotare o registrarsi.",
    copyDirectLink: "🔗 Copia Link Diretto",
    linkCopied: "Link di prenotazione copiato negli appunti!",
    googleCalSync: "Sincronizzazione Google Calendar",
    googleCalDesc: "Invia automaticamente i nuovi appuntamenti al tuo Google Calendar personale per evitare doppie prenotazioni.",
    connectCalendar: "Collega Calendario",
    connectedGoogle: "✓ Connesso a Google",
    staffInviteCode: "Codice Invito Staff",
    staffInviteDesc: "Dai questo codice ai tuoi barbieri quando si registrano.",
    shopProfileSetup: "Configurazione Profilo Salone",
    mapAddressLabel: "Indirizzo Mappa Reale (Necessario per i Pin)",
    mapAddressPlaceholder: "Inizia a digitare l'indirizzo reale...",
    shopCoverPhoto: "Foto di Copertina del Salone",
    changePhoto: "Cambia Foto",
    uploadCoverPhoto: "Carica Foto di Copertina",
    shopVibes: "Atmosfera del Salone (Seleziona fino a 3)",
    saveShopProfile: "Salva Profilo Salone",
    dangerZone: "Zona Pericolosa",
    dangerZoneDesc: "Elimina definitivamente il tuo salone, tutti gli appuntamenti programmati e il tuo account.",
    deleteMyShop: "Elimina il Mio Salone",
    deleteConfirm: "⚠️ ATTENZIONE ⚠️\nSei sicuro di voler eliminare definitivamente il tuo salone, tutti i barbieri e il tuo account? Questa azione NON può essere annullata.",
    addNewBarber: "Aggiungi Nuovo Barbiere",
    addPhoto: "📷 Aggiungi Foto",
    photoAttached: "Foto Allegata ✅",
    barberNamePlaceholder: "Nome Barbiere...",
    addBarberBtn: "+ Aggiungi Barbiere",
    currentTeam: "Team Attuale",
    noBarbersAdmin: "Nessun barbiere aggiunto ancora.",
    updatePhoto: "Aggiorna Foto",
    thisIsMe: "🙋‍♂️ Sono io",
    thisIsYou: "✓ Sei tu",
    addService: "+ Aggiungi Servizio",
    addPortfolioPhoto: "+ Aggiungi Foto Portfolio",
    deletePhotoConfirm: "Eliminare questa foto?",
    myPersonalSchedule: "Il Mio Programma Personale",
    whichProfileTitle: "Qual è il tuo profilo?",
    whichProfileDesc: "Non ci hai ancora detto quale professionista sei. Vai alla scheda Team e clicca \"Sono io\" accanto al tuo nome per sbloccare il tuo calendario.",
    goToTeamTab: "Vai alla Scheda Team",
    myPortfolio: "Il Mio Portfolio",
    addPhotoBtn: "+ Aggiungi Foto",
    noPortfolioDesc: "Non hai ancora caricato nessuna foto. Aggiungine alcune per apparire nel Feed della Community!",
    dailyCalendar: "Calendario Giornaliero",
    shopClosedDate: "Il salone è chiuso in questa data.",
    confirmed: "Confermato",
    availableSlot: "Slot Disponibile",
    addWalkIn: "+ Aggiungi Walk-in",
    walkInNamePrompt: "Inserisci il Nome del Cliente Walk-in:",
    walkInServicePrompt: "Inserisci il Nome del Servizio (es. Taglio):",
    walkInAdded: "Walk-in aggiunto! Aggiorna la pagina per vederlo nella griglia.",
    profileNotFound: "Profilo non trovato.",
    addNewService: "Aggiungi Nuovo Servizio",
    serviceName: "Nome Servizio",
    price: "Prezzo",
    duration: "Durata",
    durationPlaceholder: "es. 30m o 1h",
    saveService: "Salva Servizio",
    profileLinkedSuccess: "Successo! Questo profilo è ora collegato al tuo account proprietario.",
    settingsSaved: "Impostazioni Salone Salvate! Il tuo profilo è aggiornato.",
    inviteShareText: "Prenota il tuo prossimo taglio con noi su BookMyStyle! Cerca il nostro salone o usa il nostro codice:",
    inviteShareTitle: "Prenota con noi su BookMyStyle",
    inviteShareCopied: "Codice invito e link copiati! Puoi incollarli su Instagram o WhatsApp.",
    
    // Footer
    forClients: "Per i Clienti",
    searchLocations: "Cerca Posizioni",
    leaveReview: "Lascia una Recensione",
    supportCenter: "Centro Assistenza",
    forPartners: "Per i Proprietari",
    registerShop: "Registra il tuo Salone",
    pricingPlans: "Piani Tariffari",
    partnerDashboard: "Dashboard Proprietario",
    staffManagement: "Gestione Personale",

    howItWorksTitle: "Come Funziona",
    forClients: "Per i Clienti",
    forProfessionals: "Per i Professionisti",
    forOwners: "Per i Titolari",
    tabClients: "Clienti",
    tabStaff: "Professionisti",
    tabOwners: "Titolari",
    stepText: "FASE",
    backToHome: "← Torna alla Home",
    clientStep1Title: "Scopri e Scegli",
    clientStep1Desc: "Sfoglia i migliori professionisti della tua città. Filtra per atmosfera, servizi e disponibilità per trovare il tuo abbinamento perfetto.",
    clientStep2Title: "Prenota all'Istante",
    clientStep2Desc: "Seleziona una fascia oraria libera e prenota il tuo appuntamento in pochi secondi. Basta infinite telefonate o attese per le risposte.",
    clientStep3Title: "Presentati e Goditi il Servizio",
    clientStep3Desc: "Arriva in negozio, goditi il tuo servizio premium e rinasci con un nuovo look. Pagamenti e recensioni sono gestiti senza problemi.",
    staffStep1Title: "Crea il tuo Portfolio",
    staffStep1Desc: "Carica le foto dei tuoi tagli migliori nel tuo lookbook personale. I tuoi lavori vengono pubblicati direttamente nella pagina della community della città.",
    staffStep2Title: "Controlla la tua Poltrona",
    staffStep2Desc: "Imposta i tuoi servizi specifici, durata e prezzi. Aggiorna la tua storia quotidiana per far sapere ai clienti quando hai un posto libero.",
    staffStep3Title: "Fidelizza i Clienti",
    staffStep3Desc: "I clienti possono aggiungere il tuo profilo ai preferiti e prenotarti direttamente. Trasforma i clienti occasionali in clienti abituali per tutta la vita.",
    ownerStep1Title: "Registrati e Crea il Profilo",
    ownerStep1Desc: "Crea il tuo account titolare. Carica una foto di copertina di alta qualità, imposta il tuo indirizzo fisico e inserisci il pin esatto sulla mappa in modo che i clienti possano arrivare facilmente alla tua porta.",
    ownerStep2Title: "Definisci Atmosfera e Orari",
    ownerStep2Desc: "Seleziona fino a 3 tag atmosfera (come 'Sala PS5' o 'Birra Gratis') per attirare la tua clientela ideale. Configura i tuoi orari di lavoro settimanali in modo che i clienti sappiano esattamente quando sei aperto.",
    ownerStep3Title: "Aggiungi Barbieri e Servizi",
    ownerStep3Desc: "Genera un Codice Invito Staff univoco. Man mano che i tuoi barbieri creano account e si uniscono al tuo negozio, puoi definire i loro servizi specifici, prezzi e durate.",
    ownerStep4Title: "Sincronizza e Gestisci",
    ownerStep4Desc: "Collega il tuo Google Calendar per evitare doppie prenotazioni. Gestisci i clienti senza appuntamento direttamente dalla tua dashboard mentre le prenotazioni online popolano automaticamente il tuo calendario principale.",
    ownerStep5Title: "Lancia e Cresci",
    ownerStep5Desc: "Stampa il QR code personalizzato del tuo negozio e mettilo sui tuoi specchi. Lascia che i clienti prenotino il loro prossimo taglio direttamente dalla poltrona, tieni traccia delle tue entrate giornaliere e guarda la tua attività crescere.",
  }
};
 